import { AppTileSource } from './AppTile.types';
export const shouldOpenPartnerLinkInNewTab = source => {
  return source !== AppTileSource.MPAC;
};